import { CommonEnums } from '../../common.enums';
import { LAttribute } from './lattribute';
import { Attribute } from './attribute';
import { Db_PropertyType } from '../datapoint/dbPropertyType'
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Transform_Inst } from './transfrom_inst';
import { LAttributesUtil } from 'src/app/shared/grids/lattributes/lattributes.util';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from 'src/app/shared/utils/db_propertytypes.util';
import { AttributesUtil } from 'src/app/shared/grids/attributes/attributes.util';

export class HiveTransform {
    transform_Inst: Transform_Inst;

    lAttributes: Array<LAttribute>;
    attributes: Array<Attribute>;

    nativeDbTyp_Id: number;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;

    sel_Run_PropertyType_Cd: string;
    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;

    change_Ind: string;
    gen_Tab_Change_Ind: string;
    prop_Tab_Change_Ind: string;
    in_Attr_Tab_Change_Ind: string;
    out_Attr_Tab_Change_Ind: string;
    rProp_Tab_Change_Ind: string;

    error_Cd: string;
    error_Msg: string;
    
    constructor() {
        this.setDefault()
    }

    setDefault(): void {
        this.transform_Inst = new Transform_Inst;

        this.lAttributes = new Array<LAttribute>();
        this.attributes = new Array<Attribute>();

        this.nativeDbTyp_Id = CommonEnums.defaults.LONG_VAL
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;

        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.prop_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.in_Attr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.out_Attr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.rProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;

        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(hiveTransformTmp: HiveTransform): HiveTransform {
        let hiveTransform: HiveTransform = new HiveTransform();
        hiveTransform.copyFrom(hiveTransformTmp);
        return hiveTransform;
    }

    copy(): HiveTransform {
        let hivetransformTmp: HiveTransform = new HiveTransform();

        hivetransformTmp.transform_Inst = this.transform_Inst.copy();

        hivetransformTmp.lAttributes = LAttributesUtil.getInstance().copy(this.lAttributes);
        hivetransformTmp.attributes = AttributesUtil.getInstance().copy(this.attributes);

        hivetransformTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        hivetransformTmp.ref_Id = this.ref_Id;
        hivetransformTmp.ref_Cd = this.ref_Cd;
        hivetransformTmp.fldr_Id = this.fldr_Id;

        hivetransformTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;
        hivetransformTmp.run_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.run_Properties);
        hivetransformTmp.runPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.runPropertyTypes);

        hivetransformTmp.change_Ind = this.change_Ind;
        hivetransformTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        hivetransformTmp.prop_Tab_Change_Ind = this.prop_Tab_Change_Ind;
        hivetransformTmp.in_Attr_Tab_Change_Ind = this.in_Attr_Tab_Change_Ind;
        hivetransformTmp.out_Attr_Tab_Change_Ind = this.out_Attr_Tab_Change_Ind;
        hivetransformTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;

        hivetransformTmp.error_Cd = this.error_Cd;
        hivetransformTmp.error_Msg = this.error_Msg;

        return hivetransformTmp;
    }

    copyFrom(hivetransformTmp: HiveTransform): void {
        this.transform_Inst.copyFrom(hivetransformTmp.transform_Inst);

        LAttributesUtil.getInstance().copyFrom(this.lAttributes, hivetransformTmp.lAttributes);
        AttributesUtil.getInstance().copyFrom(this.attributes, hivetransformTmp.attributes);

        this.nativeDbTyp_Id = hivetransformTmp.nativeDbTyp_Id;
        this.ref_Id = hivetransformTmp.ref_Id;
        this.ref_Cd = hivetransformTmp.ref_Cd;
        this.fldr_Id = hivetransformTmp.fldr_Id;

        this.sel_Run_PropertyType_Cd = hivetransformTmp.sel_Run_PropertyType_Cd;
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.run_Properties, hivetransformTmp.run_Properties);
        Db_PropertyTypesUtil.getInstance().copyFrom(this.runPropertyTypes, hivetransformTmp.runPropertyTypes);

        this.change_Ind = hivetransformTmp.change_Ind;
        this.gen_Tab_Change_Ind = hivetransformTmp.gen_Tab_Change_Ind;
        this.prop_Tab_Change_Ind = hivetransformTmp.prop_Tab_Change_Ind;
        this.in_Attr_Tab_Change_Ind = hivetransformTmp.in_Attr_Tab_Change_Ind;
        this.out_Attr_Tab_Change_Ind = hivetransformTmp.out_Attr_Tab_Change_Ind;
        this.rProp_Tab_Change_Ind = hivetransformTmp.rProp_Tab_Change_Ind;

        this.error_Cd = hivetransformTmp.error_Cd;
        this.error_Msg = hivetransformTmp.error_Msg;
    }

    compare(hivetransformTmp: HiveTransform) {
        let hivetransformstring: string = toString();
        let hivetransformTmpstring: string = hivetransformTmp.toString();

        if (hivetransformstring != hivetransformTmpstring) {
            return hivetransformstring + ',' + hivetransformTmpstring
        }
        return '';
    }

    toString(): string {
        return "HiveTransform [transform_Inst  =" + this.transform_Inst.toString() +
            ", lAttributes=" + LAttributesUtil.getInstance().toString(this.lAttributes) +
            ", attributes=" + AttributesUtil.getInstance().toString(this.attributes) +
            ", nativeDbTyp_Id=" + this.nativeDbTyp_Id + ", change_Ind=" + this.change_Ind +
            ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg + ", ref_Id=" + this.ref_Id +
            ", ref_Cd=" + this.ref_Cd + ", fldr_Id=" + this.fldr_Id +
            ", sel_Run_PropertyType_Cd=" + this.sel_Run_PropertyType_Cd +
            ", run_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.run_Properties) +
            ", runPropertyTypes=" + Db_PropertyTypesUtil.getInstance().toString(this.runPropertyTypes) +
            ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind + ", prop_Tab_Change_Ind=" + this.prop_Tab_Change_Ind +
            ", in_Attr_Tab_Change_Ind=" + this.in_Attr_Tab_Change_Ind + ", out_Attr_Tab_Change_Ind=" + this.out_Attr_Tab_Change_Ind +
            ", rProp_Tab_Change_Ind=" + this.rProp_Tab_Change_Ind + "]";
    }
}